import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import React from 'react';
import { useState } from 'react';

import '../../../index.css';
import updateDB from '../../../utils/updateDB';

//import { Link } from "react-router-dom";
//import { slugify } from "../../../utils/slugify";

function GolfClubMembershipFees({
  club,
  user,
  editableCourses,
  editPermissions,
  username,
  fetchClub,
  homeGolfClub,
}) {
  const [isEditMode, setIsEditMode] = useState(false);
  const [stateValues, setStateValues] = useState({
    adult_annual_fee: club ? club.adult_annual_fee : 0,
    adult_join_fee: club ? club.adult_join_fee : 0,
    intermediate_join_fee: club ? club.intermediate_join_fee : 0,
    intermediate_annual_fee: club ? club.intermediate_annual_fee : 0,
    intermediate_start_age: club ? club.intermediate_start_age : 0,
    intermediate_end_age: club ? club.intermediate_end_age : 0,
    flexible_join_fee: club ? club.flexible_join_fee : 0,
    flexible_annual_fee: club ? club.flexible_annual_fee : 0,
    social_join_fee: club ? club.social_join_fee : 0,
    social_annual_fee: club ? club.social_annual_fee : 0,
    fiveday_join_fee: club ? club.fiveday_join_fee : 0,
    fiveday_annual_fee: club ? club.fiveday_annual_fee : 0,
    intermediate_start_join_fee: club ? club.intermediate_start_join_fee : 0,
    intermediate_end_join_fee: club ? club.intermediate_end_join_fee : 0,
    intermediate_start_annual_fee: club
      ? club.intermediate_start_annual_fee
      : 0,
    intermediate_end_annual_fee: club ? club.intermediate_end_annual_fee : 0,
    student_join_fee: club ? club.student_join_fee : 0,
    student_annual_fee: club ? club.student_annual_fee : 0,
    junior_join_fee: club ? club.junior_join_fee : 0,
    junior_annual_fee: club ? club.junior_annual_fee : 0,
    overseas_join_fee: club ? club.overseas_join_fee : 0,
    overseas_annual_fee: club ? club.overseas_annual_fee : 0,
    domestic1_join_fee: club ? club.domestic1_join_fee : 0,
    domestic1_annual_fee: club ? club.domestic1_annual_fee : 0,
    domestic2_join_fee: club ? club.domestic2_join_fee : 0,
    domestic2_annual_fee: club ? club.domestic2_annual_fee : 0,
  });

  //last edited time
  const [lastEditedBy, setLastEditedBy] = useState(
    club && club.last_edited_by
      ? club.last_edited_by[club.last_edited_by.length - 1]
      : '',
  );
  const [lastEditedTime, setLastEditedTime] = useState(
    club && club.last_edited_time
      ? club.last_edited_time[club.last_edited_time.length - 1]
      : '',
  );

  const canEdit = () => {
    if (!user) return false;
    if (editPermissions === 'Advanced' || editPermissions === 'Ambassador')
      return true;
    if (
      (editPermissions === 'Basic' ||
        editPermissions === 'Ambassador' ||
        editPermissions === 'Editor') &&
      club.club_name.includes(homeGolfClub)
    ) {
      return true;
    }
    return false;
  };

  const generateInputField = (fieldName) => {
    let fieldValue = stateValues[fieldName];

    // If not in edit mode, format the value for display
    if (!canEdit() || !isEditMode) {
      // Explicitly check for a value of 0 or "0.00" and return a hyphen
      if (parseFloat(fieldValue) === 0) {
        return '0';
      }
      // Return the value or a hyphen if the value is falsy (including null)
      return fieldValue ? fieldValue.toString() : '-';
    }

    // In edit mode, return an input field
    return (
      <input
        type="text"
        value={fieldValue != null ? fieldValue.toString() : ''}
        onChange={(e) => handleFeeChange(fieldName, e.target.value)}
        className="form-input block max-w-[50px] max-h-[25px] sm:h-fit mx-auto px-3 py-2 placeholder-gray-500 border border-slate-200 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5 text-xs md:max-w-[75px]"
      />
    );
  };

  // Generic edit handling function
  const handleFeeChange = (fieldName, value) => {
    const newValue = value === '' ? '' : parseInt(value, 10);
    setStateValues((prevState) => ({ ...prevState, [fieldName]: newValue }));

    if (isEditMode) {
      updateDB(
        'golf_clubs',
        { [fieldName]: newValue },
        'club_name',
        club.club_name,
      )
        .then(() => fetchClub())
        .catch((error) => console.error('Error updating database:', error));
    }
  };

  const saveAllChanges = async () => {
    if (isEditMode) {
      console.log('saveAllChanges triggered');
      try {
        // Update the club with the new fee data
        await updateDB('golf_clubs', stateValues, 'club_name', club.club_name);

        // Update logic for last edited by and time
        const current_date = new Date().toISOString().slice(0, 10); // YYYY-MM-DD format
        setLastEditedBy(username);
        setLastEditedTime(current_date);

        // Update last edited by and time
        await updateDB(
          'golf_clubs',
          {
            last_edited_by: [...(club.last_edited_by || []), username],
            last_edited_time: [...(club.last_edited_time || []), current_date],
          },
          'club_name',
          club.club_name,
        );

        // Refetch club information after saving all changes
        fetchClub();

        console.log('All changes saved successfully!');
      } catch (error) {
        console.error('Error saving changes:', error);
      }

      setIsEditMode(false); // Exit edit mode
    }
  };

  return (
    <section
      id="clubMembershipFees"
      className="mt-2 w-full max-w-screen xl:flex xl:min-h-0 xl:flex-col xl:h-full"
    >
      <article className="flex h-full w-full min-h-0 flex-col py-6 prose max-w-none prose-sm text-left border border-gray-300 rounded-xl bg-white shadow-lg xl:flex-1">
        <h2 className="text-center truncate px-6">
          Membership Fees (
          {club && club.membership_currency ? club.membership_currency : ''}
          {''}): <span className="text-indigo-700">{club.club_name}</span>
        </h2>
        <div className="mx-auto max-w-3xl flex justify-between gap-x-2 sm:gap-x-10 px-2">
          {isEditMode ? (
            <>
              <button
                onClick={() => setIsEditMode(false)}
                className="w-full py-2 px-4 bg-red-500 hover:bg-red-700 text-white font-semibold rounded-lg flex items-center justify-center"
              >
                <FontAwesomeIcon icon={solid('eject')} className="mr-2" />
                Cancel
              </button>
              <button
                onClick={saveAllChanges}
                className="w-full py-2 px-4 bg-green-500 hover:bg-green-700 text-white font-semibold rounded-lg flex items-center justify-center"
              >
                <FontAwesomeIcon icon={solid('floppy-disk')} className="mr-2" />
                Save Changes
              </button>
            </>
          ) : canEdit() ? (
            <button
              onClick={() => setIsEditMode(true)}
              className="mx-auto max-w-[200px] w-full py-2 px-4 bg-blue-500 hover:bg-blue-700 text-white font-semibold rounded-lg flex items-center justify-center"
            >
              <FontAwesomeIcon icon={solid('user-pen')} className="mr-2" />
              Edit Table
            </button>
          ) : null}
        </div>

        {lastEditedBy && lastEditedTime && (
          <p className="text-center text-xs italic px-2">
            Last edited {lastEditedTime}
          </p>
        )}
        <table className="mx-auto max-w-xl table-bordered border-2 border-slate-500 text-xs sm:text-sm">
          <thead className="bg-indigo-600 text-white">
            <tr>
              <th className="border border-slate-500 text-white hidden sm:table-cell">
                Golf Club:
              </th>
              <th
                className="border border-slate-500 text-white text-center pt-2"
                colSpan={4}
              >
                {club.club_name}
              </th>
            </tr>
          </thead>

          <tbody>
            {/* Fees Section */}
            <tr>
              <td
                className="font-bold bg-slate-700 text-white text-center align-middle sm:hidden"
                colSpan={4}
              >
                Membership Types & Fees
              </td>
            </tr>

            <tr>
              <td
                colSpan={2}
                className="font-bold bg-slate-500 text-white align-middle hidden sm:table-cell"
              >
                Membership Type
              </td>
              <td
                colSpan={2}
                className="font-bold bg-slate-500 text-white align-middle sm:hidden"
              >
                Membership Type
              </td>
              <td className="bg-slate-500 text-white">
                Joining Fee {club.membership_currency}
              </td>
              <td className="bg-slate-500 text-white">
                Annual Fee {club.membership_currency}
              </td>
            </tr>

            {/* Full Membership */}
            <tr>
              <td className="font-bold bg-slate-100" rowSpan={2}>
                Full
              </td>
              <td>7 Day</td>
              <td>
                {generateInputField('adult_join_fee', club.adult_join_fee)}
              </td>
              <td>
                {generateInputField('adult_annual_fee', club.adult_annual_fee)}
              </td>
            </tr>
            <tr>
              <td>5 Day</td>
              <td>
                {generateInputField('fiveday_join_fee', club.fiveday_join_fee)}
              </td>
              <td>
                {generateInputField(
                  'fiveday_annual_fee',
                  club.fiveday_annual_fee,
                )}
              </td>
            </tr>

            {/* Intermediate Membership */}
            <tr>
              <td className="font-bold bg-slate-100" rowSpan={2}>
                Intermediate<br></br>
                <span className="text-xs italic text-gray-500 font-thin">
                  (Eligible Ages)
                </span>
              </td>
              <td className="italic text-gray-500 font-thin">
                {!isEditMode && <span>Start: </span>}
                {generateInputField(
                  'intermediate_start_age',
                  club.intermediate_start_age,
                )}
              </td>
              <td>
                {generateInputField(
                  'intermediate_start_join_fee',
                  club.intermediate_start_join_fee,
                )}
              </td>
              <td>
                {generateInputField(
                  'intermediate_start_annual_fee',
                  club.intermediate_start_annual_fee,
                )}
              </td>
            </tr>
            <tr>
              <td className="italic text-gray-500 font-thin">
                {!isEditMode && <span>End: </span>}
                {generateInputField(
                  'intermediate_end_age',
                  club.intermediate_end_age,
                )}
              </td>
              <td>
                {generateInputField(
                  'intermediate_end_join_fee',
                  club.intermediate_end_join_fee,
                )}
              </td>
              <td>
                {generateInputField(
                  'intermediate_end_annual_fee',
                  club.intermediate_end_annual_fee,
                )}
              </td>
            </tr>

            {/* Country Membership */}
            <tr>
              <td className="font-bold bg-slate-100" rowSpan={3}>
                Country
              </td>
              <td>Domestic 1</td>
              <td>
                {generateInputField(
                  'domestic1_join_fee',
                  club.domestic1_join_fee,
                )}
              </td>
              <td>
                {generateInputField(
                  'domestic1_annual_fee',
                  club.domestic1_annual_fee,
                )}
              </td>
            </tr>
            <tr>
              <td>Domestic 2</td>
              <td>
                {generateInputField(
                  'domestic2_join_fee',
                  club.domestic2_join_fee,
                )}
              </td>
              <td>
                {generateInputField(
                  'domestic2_annual_fee',
                  club.domestic2_annual_fee,
                )}
              </td>
            </tr>
            <tr>
              <td>Overseas</td>
              <td>
                {generateInputField(
                  'overseas_join_fee',
                  club.overseas_join_fee,
                )}
              </td>
              <td>
                {generateInputField(
                  'overseas_annual_fee',
                  club.overseas_annual_fee,
                )}
              </td>
            </tr>

            {/* flexible Membership */}
            <tr>
              <td className="font-bold bg-slate-100">Flexible</td>
              <td>Flexible</td>
              <td>
                {generateInputField(
                  'flexible_join_fee',
                  club.flexible_join_fee,
                )}
              </td>
              <td>
                {generateInputField(
                  'flexible_annual_fee',
                  club.flexible_annual_fee,
                )}
              </td>
            </tr>

            {/* Junior Membership */}
            <tr>
              <td className="font-bold bg-slate-100">Junior</td>
              <td>Under 18s</td>
              <td>
                {generateInputField('junior_join_fee', club.junior_join_fee)}
              </td>
              <td>
                {generateInputField(
                  'junior_annual_fee',
                  club.junior_annual_fee,
                )}
              </td>
            </tr>

            {/* Social Membership */}
            <tr>
              <td className="font-bold bg-slate-100">Social</td>
              <td>No Golf</td>
              <td>
                {generateInputField('social_join_fee', club.social_join_fee)}
              </td>
              <td>
                {generateInputField(
                  'social_annual_fee',
                  club.social_annual_fee,
                )}
              </td>
            </tr>
          </tbody>
        </table>
        <div className="min-h-0 flex-1 xl:block" aria-hidden="true" />
      </article>
    </section>
  );
}
export default GolfClubMembershipFees;
